/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import { getHubbelPageData, openImageViewModal } from "../../helpers";
import { Link, useParams } from "react-router-dom";
import "./Web1920155.css";
import background_2 from "../../static/n-images/orion.png";
import fullimage from "../../static/n-images/orion.jpg";
import background_3 from "../../static/n-images/flame nebula cropped.jpg";
import background_4 from "../../static/n-images/westerlund.png";
import background_5 from "../../static/n-images/cosmic.png";
import background_7 from "../../static/n-images/flame.jpg";
import background_8 from "../../static/n-images/Done-STScI-01EVT2R4M58JN5WT7CQ998A5VD.jpg";
import nasalogo from "../../static/img/NASA_Insignia.png";
import fullImage from "../../static/n-images/pillarsOfCreation.jpg";


function Web1920155(props) {
  let { reload, videoIndex } = useParams();
  const { pillar_video, orion_nebula_video } = props;
  let video = videoIndex === "1" ? pillar_video : orion_nebula_video;
  const {
    flyThrough,
    turnToSound,
    learnMore,
    group42,
    group287,
    group45,
    wingright,
    leftwing,
    rocket,
    music,
    group583,
    click_me,
    travelAgainInGalaxies,
    flyBackToSolarSystem,
    travelAgainInMilkyWay
  } = props;
  const [randomObject, setRandomObject] = useState([]);
  const slideToggleButton = useRef();
  const slideToggleBox = useRef();

  useEffect(() => {
    if (slideToggleBox && slideToggleBox.current) {
      const stButton = slideToggleButton.current;
      stButton.addEventListener("click", function () {
        slideToggleBox.current.classList.toggle("panel-active");
        slideToggleButton.current.classList.toggle("panel-btn-active");
      });
    }

    setRandomObject(getHubbelPageData(onPageData, reload));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slideToggleBox]);

  let onPageData = [
    {
      randomPageTitle: "Pillars of Creation",
      randomPageDescription:
        "These pillars of gas and dust in the Eagle Nebula are the birthplace of stars. Stars are being born deep inside the pillars, which are made of cold hydrogen gas laced with dust. The pillars are bathed in the ultraviolet light from a grouping of young, massive stars not visible here. Streamers of gas are bleeding off the pillars as the intense radiation heats and evaporates it into space, while denser regions of the pillars shadow material beneath them from the powerful radiation. These towering pillars are about 5 light-years tall.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-goes-high-def-to-revisit-the-iconic-pillars-of-creation/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(fullImage, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_8,
      videoPageLink: "/web-1920-145/1",
    },
    {
      randomPageTitle: "Orion Nebula",
      randomPageDescription:
        "The Orion Nebula is a tumultuous region of dust and gas where thousands of stars are being born. More than 3,000 stars appear here in a dramatic landscape of plateaus, mountains, and valleys. The bright central region is home to the four most massive stars in the nebula, called the Trapezium. Ultraviolet light unleashed by these stars is carving a cavity in the nebula and influencing the growth of hundreds of smaller stars.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-panoramic-view-of-orion-nebula-reveals-thousands-of-stars/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(fullimage, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_2,
      videoPageLink: "/web-1920-145/2",
    },
    {
      randomPageTitle: "Flame Nebula",
      randomPageDescription:
        "The Flame Nebula, also called NGC 2024, is a large star-forming region that lies about 1,400 light-years from Earth. Here we see the dark, dusty heart of the nebula, where a star cluster resides but is mostly hidden from view. Radiation from the nearby bright star Alnitak ionizes the Flame Nebula’s hydrogen gas. As the gas begins to cool from its higher-energy state to a lower-energy state, it emits energy in the form of light, causing the visible glow behind the swirled wisps of dust.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-spots-swirls-of-dust-in-the-flame-nebula/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_7, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_3,
    },
    {
      randomPageTitle: "Westerlund 2",
      randomPageDescription:
        "This is a giant cluster of about 3,000 stars called Westerlund 2. The giant star cluster is only about 2 million years old and contains some of our galaxy's hottest, brightest, and most massive stars. Some of its heftiest stars unleash torrents of ultraviolet light and hurricane-force winds of charged particles that etch at the enveloping hydrogen gas cloud. The brilliant stars sculpt the gaseous terrain of the nebula and help create a successive generation of baby stars.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/asset/hubble/nasa-unveils-celestial-fireworks-as-official-hubble-25th-anniversary-image/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_4, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_4,
      videoPageLink: "/web-1920-117/1",
    },

    {
      randomPageTitle: "Cosmic Reef",
      randomPageDescription:
        "The red nebula (NGC 2014) and its blue neighbor (NGC 2020) are part of a vast star-forming region in the Large Magellanic Cloud. Here young, energetic, massive stars illuminate and sculpt their birthplace with powerful winds and searing ultraviolet radiation. The gas of NGC 2014 is shaped by a group of bright, hefty stars, each 10 to 20 times more massive than our Sun. NGC 2020 has been created by a solitary mammoth star 200,000 times brighter than our Sun, which has ejected the surrounding gas over time.",
      learnMoreLink: (
        <React.Fragment>
          <div className="view_img-rem">
            <a target="_blank" rel="noreferrer" href="https://science.nasa.gov/missions/hubble/hubble-marks-30-years-in-space-with-tapestry-of-blazing-starbirth/">Learn More</a>
            <span>|</span>
            <h3 onClick={(e) => openImageViewModal(background_5, e)}>
              <u>View Full Image</u>
            </h3>
          </div>
        </React.Fragment>
      ),
      background: background_5,
      videoPageLink: "/web-1920-117/2",
    },
  ];

  return (
    <div className="container-center-horizontal">
      <div className="panel">
        {/* <a href="#" className="nBtn" ref={panelHolderButton}></a> */}
        <button className="panel-toggle-button" ref={slideToggleButton}>
          <p className="open-panel">
            <img className="arrow" src={click_me} /> OPEN CONTROL PANEL
          </p>
          <p className="close-panel">
            <img className="arrow" src={click_me} /> CLOSE CONTROL PANEL
          </p>
        </button>
        <div className="panel-box panel-active" ref={slideToggleBox}>
          <div className="contentbox">
            <div className="left">
              <img src={leftwing} className="wing_left" />

              <div className="the-antennae-galaxies lato-bold-white-30px">
                {randomObject.randomPageTitle}
              </div>

              {randomObject.learnMoreLink}

              <div className="the-antennae-galaxie lato-medium-white-26px">
                {randomObject.randomPageDescription}
              </div>
            </div>

            <div className="right">
              <img src={wingright} className="wing_right" />
              {randomObject.randomPageTitle === "Pillars of Creation" && (
                <>
                  <Link to={`${randomObject.videoPageLink}`}>
                    <div className="innerbtn-btn fly">
                      <div className="web192010-btn-img">
                        <div
                          className="web192010-bg-img"
                          style={{ backgroundImage: `url(${music})` }}
                        ></div>
                      </div>
                      {turnToSound}
                    </div>
                  </Link>
                </>
              )}

              {randomObject.randomPageTitle != "Pillars of Creation" &&
                randomObject.randomPageTitle != "Flame Nebula" && (
                  <Link to={`${randomObject.videoPageLink}`}>
                    <div className="innerbtn-btn fly">
                      <div className="web192010-btn-img">
                        <div
                          className="web192010-bg-img"
                          style={{ backgroundImage: `url(${rocket})` }}
                        ></div>
                      </div>
                      {flyThrough}
                    </div>
                  </Link>
                )}

              <Link to="/explore-our-milky-way">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group287})` }}
                    ></div>
                  </div>
                  {travelAgainInMilkyWay}
                </div>
              </Link>

              <Link to="/investigate-our-solar-system">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group42})` }}
                    ></div>
                  </div>
                  {flyBackToSolarSystem}
                </div>
              </Link>
              <Link to="/i-want-to-see-a-different-galaxy">
                <div className="innerbtn-btn1">
                  <div className="web192010-btn-img">
                    <div
                      className="web192010-bg-img"
                      style={{ backgroundImage: `url(${group45})` }}
                    ></div>
                  </div>
                  {learnMore}
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="web-1920-155 screen">
        <div className="overlap-group">
          <img
            className="x27950248711_d1329dfb69_6k"
            src={randomObject.background}
          />

          <Link to="/web-1920-10">
            <div
              className="group-583"
              style={{ backgroundImage: `url(${group583})` }}
            ></div>
          </Link>
        </div>
      </div>

      <Link to="/web-1920-10">
        <div
          className="group-583_13 home-btn-pos"
          style={{ backgroundImage: `url(${group583})` }}
        ></div>
      </Link>

      {/* ham-menu-start */}

      <div className="container">
        <input type="checkbox" name="" id="" className="check" />
        <ul className="menu-items">
          <Link to="/i-want-to-see-a-different-galaxy">
            <div className="innerbtn-btn1">{travelAgainInGalaxies}</div>
          </Link>

          <Link to="/investigate-our-solar-system">
            <div className="innerbtn-btn1">{flyBackToSolarSystem}</div>
          </Link>

          <Link to="/explore-our-milky-way">
            <div className="innerbtn-btn1">
              EXPLORE OUR <br /> GALAXY
            </div>
          </Link>
        </ul>
        <div className="ham-menu">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </div>
      </div>

      {/* ham-menu-end */}
      <a href="https://www.nasa.gov/" className="nasalogo" target="_blank"  rel="noreferrer"><img alt="img" src={nasalogo} /> </a>

      <div className="hds-footer-socials margin-bottom-2">
        <h3 className="heading-16 color-carbon-40 margin-bottom-2">Visit Us <br></br><a className="text-dark" href="https://science.nasa.gov/mission/hubble" target="_blank" rel="noreferrer">nasa.gov/hubble</a></h3>

        <h4><span>@NASA</span>Hubble</h4>
        <ul className="social-icons margin-bottom-3">
          <li>
            <a href="https://www.facebook.com/NASAHubble" title="Hubble on Facebook" target="_blank" rel="noreferrer"><svg alt="Facebook" width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="https://www.w3.org/2000/svg"><path d="M8.55557 4.25966H6.95557C6.31794 4.25966 6.1852 4.52158 6.1852 5.18173V6.63003H8.55557L8.30787 9.0004H6.1852V17.2967H2.62965V9.0004H0.259277V6.63003H2.62965V3.89462C2.62965 1.79803 3.73306 0.704102 6.21957 0.704102H8.55557V4.25966Z" fill="#F7F5F4"></path></svg></a>
          </li>
          <li>
            <a href="https://www.instagram.com/NASAHubble/" title="Hubble on Instagram" target="_blank" rel="noreferrer"><svg alt="Instagram" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="https://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M4.74015 9.0004C4.74015 11.3542 6.64829 13.2611 9.00089 13.2611C11.3535 13.2611 13.2616 11.353 13.2616 9.0004C13.2616 6.6478 11.3535 4.74084 9.00089 4.74084C6.64829 4.74084 4.74015 6.6478 4.74015 9.0004ZM11.7625 9.00037C11.7625 10.5281 10.524 11.7654 8.9975 11.7654C7.47098 11.7654 6.23247 10.5281 6.23247 9.00037C6.23247 7.47267 7.47098 6.23533 8.9975 6.23533C10.524 6.23533 11.7625 7.47267 11.7625 9.00037Z" fill="#F7F5F4"></path><path d="M12.4344 4.57255C12.4344 5.12247 12.88 5.5681 13.4299 5.5681C13.9798 5.5681 14.4255 5.12129 14.4255 4.57255C14.4255 4.02262 13.9798 3.57699 13.4299 3.57699C12.88 3.57699 12.4344 4.02262 12.4344 4.57255Z" fill="#F7F5F4"></path><path fillRule="evenodd" clipRule="evenodd" d="M12.4225 17.2469C15.4317 17.1083 17.1111 15.4371 17.2474 12.4208C17.2877 11.5367 17.2972 11.2534 17.2972 9.0004C17.2972 6.74736 17.2877 6.46529 17.2474 5.57995C17.1123 2.57077 15.4388 0.893731 12.4225 0.755065C11.5372 0.713583 11.2539 0.704102 9.00089 0.704102C6.74785 0.704102 6.46578 0.713583 5.58044 0.755065C2.56652 0.892546 0.893034 2.56484 0.754367 5.57995C0.714071 6.46529 0.70459 6.74736 0.70459 9.0004C0.70459 11.2534 0.714071 11.5367 0.754367 12.4208C0.893034 15.4348 2.56533 17.1083 5.58044 17.2469C6.46578 17.2872 6.74785 17.2967 9.00089 17.2967C11.2539 17.2967 11.5372 17.2872 12.4225 17.2469ZM9.00089 2.19981C11.216 2.19981 11.4791 2.20692 12.3538 2.24721C14.6021 2.35032 15.651 3.41699 15.7553 5.64869C15.7944 6.52336 15.8027 6.78529 15.8027 9.0004C15.8027 11.2155 15.7944 11.4786 15.7553 12.3533C15.651 14.5838 14.6044 15.6528 12.3538 15.7548C11.4791 15.7951 11.2172 15.8034 9.00089 15.8034C6.78577 15.8034 6.52266 15.7939 5.64918 15.7548C3.39378 15.6517 2.35081 14.5803 2.2477 12.3533C2.20859 11.4774 2.19911 11.2155 2.19911 9.0004C2.19911 6.78529 2.20859 6.52336 2.2477 5.64869C2.35081 3.41581 3.39852 2.35032 5.64918 2.24721C6.52385 2.2081 6.78577 2.19981 9.00089 2.19981Z" fill="#F7F5F4"></path></svg></a>
          </li>
          <li>
            <a href="https://twitter.com/nasahubble" title="Hubble on X" target="_blank" rel="noreferrer"><svg alt="X" width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"></path></svg></a>
          </li>
            <li>
            <a href="https://www.flickr.com/photos/nasahubble/" title="Hubble on Flickr" target="_blank" rel="noreferrer">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Hubble on Flickr</title><path d="M11 12C11 14.7615 8.76146 17 5.99998 17 3.23849 17 1 14.7615 1 12 1 9.23899 3.23849 7 5.99998 7 8.76146 7 11 9.23899 11 12ZM23 12C23 14.7615 20.7615 17 18 17 15.2385 17 13 14.7615 13 12 13 9.23899 15.2385 7 18 7 20.7615 7 23 9.23899 23 12Z"></path></svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Web1920155;
